export const ROUTE_BASE_NAME = "users";

export const ROUTE_NAMES = {
  List: `${ROUTE_BASE_NAME}.list`,
  Create: `${ROUTE_BASE_NAME}.create`,
};
